import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles((theme: Theme) => ({
  dataGridContainer: {
    minWidth: 400,
  }
}));

export default styles;